import Card from "react-bootstrap/Card"
import Container from "react-bootstrap/Container"
import { useTranslation } from "react-i18next"
import "../styles/Feedback.css"
import CardTitle from "react-bootstrap/esm/CardTitle"
import CardBody from "react-bootstrap/esm/CardBody"
import Icon from "./Icon"

const Feedback = () => {
  const { t } = useTranslation()

  return (
    <Container className="BREIKKI-feedback-container">
      <h1 className="BREIKKI-feedback-title">
        {t("feedback_title")}
      </h1>
      <Icon className="BREIKKI-feedback-icon" feedback width={100} height={100} />
      <Card className="BREIKKI-feedback-links-card">
        <CardTitle className="BREIKKI-feedback-links-card-title">
          <span className="BREIKKI-feedback-info-text">{t("feedback_info_text")}</span>
        </CardTitle>
        <CardBody className="BREIKKI-feedback-links-card-body">
          <div className="BREIKKI-link-list">
            <a className="BREIKKI-feedback-link" href="https://forms.office.com/e/cZeWqMiC1d">{t("feedback_general_link_text")}</a>
            <a className="BREIKKI-feedback-link" href="https://forms.office.com/e/9i1kJJKY2A">{t("feedback_website_link_text")}</a>
          </div>
        </CardBody>
      </Card>
    </Container>
  )
}

export default Feedback